__turbopack_context__.v({
  "container": "u42vNa_container",
  "loader": "u42vNa_loader",
  "message": "u42vNa_message",
  "overlay": "u42vNa_overlay",
  "spin": "u42vNa_spin",
  "spinner": "u42vNa_spinner",
});
